import React from 'react';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';
import { FormikFieldString } from 'Components/FormikComponents';
import { Select, Label } from '@brighterion/br-ui';
import { MERCHANT_OPTIONS } from 'Common/enums';
import styles from './styles.css';

type Props = {
    error: any;
    formikProps: FormikProps<any>;
};

const MerchantField = ({ error, formikProps }: Props) => {
    const { t } = useTranslation();

    return (
        <div className={styles.formBlock}>
            <Label label={t('Merchant')} id='merchantId' />
            <div className={styles.fieldsContainer}>
                <Select
                    id='merchantOption'
                    name='merchantOption'
                    selectedItems={formikProps.values.merchantOption || [MERCHANT_OPTIONS.ALL_MERCHANTS]}
                    handleClickCallback={(value) => {
                        formikProps.setValues({ ...formikProps.values, merchantOption: value, merchantId: '' });
                    }}
                    size='sm'
                    disabled={formikProps.isSubmitting}
                    dataTestId='list-entry-merchant-selector'
                >
                    <option value={MERCHANT_OPTIONS.ALL_MERCHANTS}>{t('All Merchants')}</option>
                    <option value={MERCHANT_OPTIONS.SINGLE_MERCHANT}>{t('Single Merchant')}</option>
                </Select>
                <FormikFieldString
                    name='merchantId'
                    handleChange={(e: React.ChangeEvent) => {
                        formikProps.handleChange(e);
                    }}
                    handleBlur={formikProps.handleBlur}
                    error={
                        !!(formikProps.errors.merchantId && formikProps.touched.merchantId) ||
                        error?.data?.error?.param === 'merchantId'
                    }
                    errorMsg={formikProps.errors.merchantId as string}
                    placeholder={t('Enter MID')}
                    dataTestId='list-entry-merchant-field'
                    disabled={
                        formikProps.values.merchantOption[0] === MERCHANT_OPTIONS.ALL_MERCHANTS ||
                        formikProps.isSubmitting
                    }
                />
            </div>
            <div className='InputBase__optionalText'>{t('addListEntry.merchantValidation')}</div>
        </div>
    );
};

export default React.memo(MerchantField);
